<template>
  <div>
    <ElibraryMain kategori="buletin"></ElibraryMain>
    <AppFooter></AppFooter>
  </div>
</template>

<script>
import ElibraryMain from "@/components/public-e-library/ElibraryMain.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: 'ELibraryBuletinView',
  components: {
    AppFooter,
    ElibraryMain
  },
  data() {
    return {

    }
  },
  methods: {
  },
  mounted() {
  }

}
</script>

<style scoped>

</style>